import { render, staticRenderFns } from "./BuddhaTkOther.vue?vue&type=template&id=49042c11"
import script from "./BuddhaTkOther.vue?vue&type=script&lang=js"
export * from "./BuddhaTkOther.vue?vue&type=script&lang=js"
import style0 from "./BuddhaTkOther.vue?vue&type=style&index=0&id=49042c11&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports